import React, { createRef, Component } from "react";
import { Map, WMSTileLayer, ScaleControl, Marker,GeoJSON,  Pane, } from "react-leaflet";
import L from "leaflet";
import domain from "../domain";
import { isNull } from "util";
import colors from "../colors";
import urls from "../urls";
import { Button, Message, Icon, Popup, Menu } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Control from "react-leaflet-control";
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";

const crs = L.CRS.EPSG4326;
class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 420,
      height: 300,
      x: 0,
      y: 100,
      minZoom: 3,
      maxZoom: 13,
      zoom: window.innerWidth>1000?4:3,
      center: window.innerWidth>1000?[22.12539, 79.00164]:[20.13,80.58],
      isMenuOpened: true,
      baseLayers: true,
      url:
     urls.bhuvan_map,
     isMenuOpened: true,
      baselayerselected:
        "Map" ,
        layers:
        urls.map_layer
       
    };
  }
  displayBaseLayers = () => {
    console.log("base layers");
    this.setState({
      baseLayers: !this.state.baseLayers,
    });
  };
  changeBaseLayer = (event) => {
    let layers, url;
    //  this.findActiveLayers()
    console.log(event.target);
    if (event.target.value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
    } else if (event.target.value === "Satellite") {
      layers = urls.s_layer;
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = urls.satellite;
    } else if (event.target.value === "Basin") {
      layers = "nhp_snowcomponent:basins";
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = `${domain.Geoserver}/nhp_snowcomponent/wms`;
    }

    this.setState({
      baselayerselected: event.target.value,
      url: url,
      layers: layers,
    });
  };
  render() {
 
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
 

    return (
        <Map
          ref={this.mapRef}
          // ref={m => { this.leafletMap = m }}
          center={this.state.center}
          minZoom={this.state.minZoom}
          maxZoom={this.state.maxZoom}
          zoom={this.state.zoom}
         
          // onlayeradd={this.onLayer}
          style={{ backgroundColor: "#fff" }}
          attributionControl={false}
          crs={crs}
          dragging={true}
        // onresize={this.onResizeMap}
        >
          {this.state.baselayerselected !== null ? (
            <WMSTileLayer
              ref={this.tileRef}
              layers={this.state.layers}
              // url='http://192.168.192.103:8080/geoserver/cite/wms'
              url={this.state.url}
              format="image/png"
              transparent={true}
              // crs={ crs}
              zIndex={1}
              onloading={this.loading}
              onload={this.load}
            />
          ) : null}
           <Control position="topright">
          
              <div style={{width:"200px"}}>
                <div style={{ background: colors.final_side }}>
                  <Menu.Item
                    as="div"
                    onClick={this.displayBaseLayers}
                    style={{ textAlign: "center", marginLeft: `5px` }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.black,
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Base Layers
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.state.baseLayers ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>

                {this.state.baseLayers ? (
                  <div>
                    <input
                      type="radio"
                      name="baselayer"
                      value="Satellite"
                      checked={this.state.baselayerselected === "Satellite"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Satellite <br />
                    <input
                      type="radio"
                      name="baselayer"
                      value="Map"
                      checked={this.state.baselayerselected === "Map"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Map <br />
                    {/* <input
                      type="radio"
                      name="baselayer"
                      value="Basin"
                      checked={this.state.baselayerselected === "Basin"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Basin */}
                  </div>
                ) : null}

              
              </div>
             
                 </Control>
          </Map>)
  }
}
export default MapView;